import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() clientId;

  currentYear = new Date().getFullYear();

  constructor(
    private activatedRoute: ActivatedRoute,
    public utilsService: UtilsService,
  ) { }

  ngOnInit(): void {
    this.clientId = this.clientId ? this.clientId : this.activatedRoute.snapshot.queryParamMap.get('clientId') ?? 1
  }

}
